export const fieldReadyToSubmit = (config, formState) => {
  if (config.mandatory === false || !config.hasOwnProperty("mandatory"))
    return true;

  if (config.type === "sectionHeader") return true;

  if (
    formState.hasOwnProperty(config.id) &&
    (formState[config.id] ||
      formState[config.id] === false ||
      formState[config.id] !== "")
  ) {
    return true;
  }
  return false;
};

export const fieldWasOnceReadyToSubmit = (config, formState) => {
  if (config.mandatory === false || !config.hasOwnProperty("mandatory"))
    return false;

  if (config.type === "sectionHeader") return false;

  if (formState.hasOwnProperty(config.id)) {
    return true;
  }
  return false;
};
